export default __webpack_public_path__ + "static/media/instruction.02f31f5c.png";